<tui-root>
    <main class="px-0 md:px-8 xl:px-0 py-16">
    <section *ngIf="currentSurveyStep === 3">
        <div class="storenContainer mx-auto">
            <div *ngIf="firstPage === 2">
                <div class="text-[12px] text-right">* = Required</div>

                <div class="grey-bottom-hr">
                    <h6 class="my-2 text-[26px] font-bold">Your Storen Experience</h6>
                </div>
                <p class="mt-2 text-[14px] text-neutral-500">The following questions are about how Storen corn herbicide performed in
                    your fields. Rate your satisfaction, share the benefits you noticed, and let us know how it
                    compared
                    to other herbicides you've used.</p>
            </div>
            <section *ngIf="currentSatisfactionStep === 1">
                <form class="bg-white px-0" [formGroup]="satisfactionSurveyForm">

                    <div class="mx-auto mt-4">
                        <div class="tui-form__row">
                            <p class="text-[16px] my-2 mb-4">On a scale from 1 to 5, how satisfied are you with the
                                results
                                provided by Storen<sup>&reg;</sup> corn herbicide this season?<span class="tui-required"></span>
                            </p>
                            <div class="grid grid-cols-1 md:grid-cols-5 gap-2">
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="1"
                                            formControlName="satisfactionScaleForStorenCornHerbicide"
                                            class="color-blue" />
                                        <span>1<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span>Not satisfied at all</span>
                                    </div>
                                </label>
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="2"
                                            formControlName="satisfactionScaleForStorenCornHerbicide"
                                            class="color-blue" />
                                        <span>2<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span>Somewhat satisfied</span>
                                    </div>
                                </label>
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="3"
                                            formControlName="satisfactionScaleForStorenCornHerbicide"
                                            class="color-blue" />
                                        <span>3<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span>Neutral</span>
                                    </div>
                                </label>
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="4"
                                            formControlName="satisfactionScaleForStorenCornHerbicide"
                                            class="color-blue" />
                                        <span>4<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span>Fairly satisfied</span>
                                    </div>
                                </label>
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="5"
                                            formControlName="satisfactionScaleForStorenCornHerbicide"
                                            class="color-blue" />
                                        <span>5<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span>Extremely satisfied</span>
                                    </div>
                                </label>
                            </div>
                        </div>

                        <div class="tui-form__row mt-5">
                            <p class="text-[16px] mb-2">Please tell us about your experience with Storen this
                                season.*
                            </p>
                            <tui-textarea formControlName="experienceWithStoren" (change)="charSubstring(satisfactionSurveyForm.value.experienceWithStoren,'experienceWithStoren')"
                                [tuiTextfieldLabelOutside]="true" class="textCustom" maxlength="1000" (keypress)="characValidation(satisfactionSurveyForm.value.experienceWithStoren)"/>

                                <div class="counter">{{experienceLength || 0}}/1000</div>
                        </div>

                        <div class="tui-form__row mt-5">
                            <p class="text-[16px] mb-2">How can we improve Storen corn herbicide?<span
                                    class="tui-required"></span></p>
                            <tui-textarea formControlName="improveStorenCorn" [tuiTextfieldLabelOutside]="true" class="textCustom" maxlength="1000"
                            (keypress)="characValidation(satisfactionSurveyForm.value.improveStorenCorn)" (change)="charSubstring(satisfactionSurveyForm.value.improveStorenCorn,'improveStorenCorn')"/>
                            <div class="counter">{{improveStorenLength || 0}}/1000</div>
                        </div>

                        <div class="tui-form__row mt-5">
                            <p class="text-[16px] mb-4">On a scale from 1 to 5 stars, how would you rate Storen corn herbicide?<span class="tui-required"></span></p>
                            <div class="grid grid-cols-1 md:grid-cols-5 gap-2">
                                <label tuiLabel class="block md:mx-auto md:w-100">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="1"
                                            formControlName="selectedRatingOption" class="color-blue" />
                                        <span>1<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span class="md:min-w-fit min-w-32">Very Poor</span>
                                        <span class="flex gap-1 items-center">
                                            <ng-container *ngFor="let i of [].constructor(1)">
                                                <img src="../assets/Storen Stars 5.svg" alt="">
                                            </ng-container>
                                        </span>
                                    </div>
                                </label>
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="2"
                                            formControlName="selectedRatingOption" class="color-blue" />
                                        <span>2<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span class="md:min-w-fit min-w-32">Below average</span>
                                        <span class="flex gap-1 items-center">
                                            <ng-container *ngFor="let i of [].constructor(2)">
                                                <img src="../assets/Storen Stars 5.svg" alt="">
                                            </ng-container>
                                        </span>
                                    </div>
                                </label>
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="3"
                                            formControlName="selectedRatingOption" class="color-blue" />
                                        <span>3<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span class="md:min-w-fit min-w-32">Average</span>
                                        <span class="flex gap-1 items-center">
                                            <ng-container *ngFor="let i of [].constructor(3)">
                                                <img src="../assets/Storen Stars 5.svg" alt="">
                                            </ng-container>
                                        </span>
                                    </div>
                                </label>
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="4"
                                            formControlName="selectedRatingOption" class="color-blue" />
                                        <span>4<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span class="md:min-w-fit min-w-32">Very good</span>
                                        <span class="flex gap-1 items-center">
                                            <ng-container *ngFor="let i of [].constructor(4)">
                                                <img src="../assets/Storen Stars 5.svg" alt="">
                                            </ng-container>
                                        </span>
                                    </div>
                                </label>
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="5"
                                            formControlName="selectedRatingOption" class="color-blue" />
                                        <span>5<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span class="md:min-w-fit min-w-32">Excellent</span>
                                        <span class="flex gap-1 items-center">
                                            <ng-container *ngFor="let i of [].constructor(5)">
                                                <img src="../assets/Storen Stars 5.svg" alt="">
                                            </ng-container>
                                        </span>
                                    </div>
                                </label>
                            </div>
                        </div>

                        <div class="tui-form__row mt-5">
                            <p class="text-[16px] mb-4">Your feedback makes a difference! Thank you for sharing your
                                experience. Choose your reward below.<span class="tui-required"></span></p>
                            <div
                                class="max-w-6xl mx-auto flex items-start md:items-center justify-center gap-3 md:gap-10">
                                <div class="flex flex-col items-center w-[150px] md:w-[200px] text-center">
                                    <div
                                        class="w-full h-[150px] md:h-[200px] rounded-full flex items-center justify-center bg-gray-300">
                                        <img src="../assets/speaker.png" alt="Reward 1"
                                            class="w-[120px] h-[120px] md:w-[120px]md:h-[120px] object-contain adjust-image">
                                    </div>
                                    <label tuiLabel class="m-2 flex justify-between items-center">
                                        <div class="flex flex-col items-center">
                                            <input tuiRadio type="radio" value="SONOSPHEAR™ Wireless Bluetooth® speaker"
                                                [formControl]="satisfactionSurveyForm.controls['selectedRewardOption']"
                                                class="color-blue" />
                                            <span class="mt-2">SONOSPHEAR<sup>&trade;</sup> Wireless Bluetooth<sup>&reg;</sup> speaker</span>
                                        </div>
                                    </label>
                                </div>

                                <div class="flex flex-col items-center w-[150px] md:w-[200px] text-center">
                                    <div
                                        class="w-full h-[150px] md:h-[200px] rounded-full flex items-center justify-center bg-gray-300">
                                        <img src="../assets/wallet.png"
                                            alt="Reward 2"
                                            class="w-[130px] h-[84px] md:w-[140px]md:h-[140px]object-contain">
                                    </div>
                                    <label tuiLabel class="m-2 flex justify-between items-center">
                                        <div class="flex flex-col items-center">
                                            <input tuiRadio type="radio" value="Ridge® wallet"
                                                [formControl]="satisfactionSurveyForm.controls['selectedRewardOption']"
                                                class="color-blue" />
                                            <span class="mt-2">Ridge<sup>&reg;</sup>wallet</span>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="tui-form__row">
                            <button (click)="submitSatisfactorySurvey()" tuiButton appearance="" size="m"  [disabled]="!satisfactionSurveyForm.valid"
                                class="blue-hover-effect rounded-0 w-full font-bold text-[#FFFFFF] bg-dark-blue">
                                Submit
                            </button>
                        </div>
                    </div>
                </form>

            </section>

            <section class="bg-white mb-5" *ngIf="currentSatisfactionStep === 2">
                <div class="row mt-5" id="satisiFacThanks">
                    <div class="mx-auto">
                        <div class="text-center" >
                            <div class="my-4 flex justify-center items-center">
                                <img src="../assets/Check.png" alt="" class="w-[92px] h-[92px] pointer-events-none">
                            </div>
                            <div class="my-4">
                                <p class="text-[36px] font-bold leading-[37px]">Thank you for your submission!</p>
                                <div class="flex flex-col gap-2 mt-4 text-neutral-500">
                                    <p class="text-[16px] leading-[24px]">Your selected reward will be shipped to
                                        the
                                        address provided during sign-up. You’ll receive an email confirmation once
                                        your
                                        reward has shipped.<span class="tui-required"></span></p>
                                    <p class="text-[16px] leading-[24px] mt-5">Limit one (1) SONOSPHEAR<sup>&trade;</sup> Wireless Speaker
                                        or
                                        Ridge<sup>&reg;</sup> Wallet per eligible participant.
                                    </p>
                                    <p class="text-[16px] leading-[24px] underline cursor-pointer"><a (click)="downloadImage('https://assets.syngentaebiz.com/pdf/media/storen-satisfaction-terms-and-conditions.pdf', '2025_SSP_Program_Sheet_Page_1 2.pdf')">View full program terms and
                                            conditions.</a></p>
                                </div>
                            </div>
                        </div>
                        <div class="m-3 mt-5">
                            <button (click)="continueToPhotoUpload()" tuiButton appearance="primary-grayscale"
                                size="m" class="rounded-0 text-white w-100 dark-btn-hover">
                                Continue to Photo Upload
                            </button>
                        </div>
                        <div class="m-3">
                            <button (click)="returnDashboard()" tuiButton appearance="outline-grayscale" size="m"
                                class="rounded-0 text-dark w-100 light-btn-hover light-btn-hover">
                                Return to Dashboard
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </section>
    </main>
    </tui-root>
